import { render, staticRenderFns } from "./NavDetail.vue?vue&type=template&id=5ed639cf&scoped=true"
import script from "./NavDetail.vue?vue&type=script&lang=js"
export * from "./NavDetail.vue?vue&type=script&lang=js"
import style0 from "./NavDetail.vue?vue&type=style&index=0&id=5ed639cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed639cf",
  null
  
)

export default component.exports